import { useState } from "react";
import { Calendar, X } from "lucide-react";
import CalendrierDashboard from "../../CalendrierDashboard";

export const CalendrierButton = ({ className = "", authUser = null }) => {
  const [showCalendrier, setShowCalendrier] = useState(false);
  
  return (
    <>
      <button
        onClick={() => setShowCalendrier(true)}
        className={`flex items-center gap-2 px-4 py-2 bg-teal-600 hover:bg-teal-500 text-white rounded-lg transition-colors ${className}`}
        data-testid="calendrier-btn"
      >
        <Calendar className="w-4 h-4" />
        Calendrier
      </button>
      
      {showCalendrier && (
        <div className="fixed inset-0 bg-black/80 z-50 overflow-auto">
          <div className="min-h-screen">
            <div className="sticky top-0 z-10 bg-slate-900 border-b border-slate-700 px-4 py-3 flex justify-between items-center">
              <h2 className="text-lg font-semibold text-white flex items-center gap-2">
                <Calendar className="w-5 h-5 text-teal-400" />
                Calendrier RDV
              </h2>
              <button
                onClick={() => setShowCalendrier(false)}
                className="p-2 hover:bg-slate-800 rounded-lg text-slate-400 hover:text-white"
              >
                <X className="w-6 h-6" />
              </button>
            </div>
            <CalendrierDashboard embedded={true} authUser={authUser} />
          </div>
        </div>
      )}
    </>
  );
};

export default CalendrierButton;
